import type { serverTimestamp } from 'firebase/firestore'
import { LogTypes, logProps } from '../utils/LoggingProps'

export interface ConfiguratorModelRef {
  id: string
  category: string
  category_2: string | null
  model: string
  model_uri: string
  vendor_name: string | null
}

export interface SurchargeBase {
  id: string
  active: boolean
  amount: number
  amount_type: 'fixed' | 'percentage'
  apply_to: 'configurators' | 'all' | 'order-line'
  calculation_order: number | 0
  description: string | null
  name: string
}

export interface SurchargeApplicable extends SurchargeBase {
  apply: boolean
}

export interface Surcharge extends SurchargeBase {
  last_modified_date?: typeof serverTimestamp | any | null
  last_modified_name?: string | null
  last_modified_email?: string | null
  last_modified_uid?: string | null
  configurators: Array<ConfiguratorModelRef>
}

export const toNewSurcharge = ({ surcharge }: { surcharge: any }): Surcharge => {
  return {
    id: surcharge?.id,
    active: surcharge.active || false,
    amount: surcharge.amount || 0,
    amount_type: surcharge.amount_type || 'percentage',
    apply_to: surcharge.apply_to || 'configurators',
    calculation_order: surcharge.calculation_order || 0,
    description: surcharge.description,
    ...logProps(LogTypes.LastModified),
    configurators: [],
    name: surcharge?.name,
  }
}

export const toSurcharge = (surcharge: any): Surcharge => {
  return {
    id: surcharge?.id,
    active: surcharge.active || false,
    amount: surcharge.amount || 0,
    amount_type: surcharge.amount_type || 'percentage',
    apply_to: surcharge.apply_to || 'configurators',
    calculation_order: surcharge.calculation_order || 0,
    description: surcharge.description,
    ...logProps(LogTypes.LastModified),
    configurators: surcharge.configurators || [],
    name: surcharge?.name,
  }
}

export const toSurchargeConfiguratorModel = (model: any): ConfiguratorModelRef => {
  return {
    id: model.id,
    category: model.category,
    category_2: model.category_2 || null,
    model: model.model,
    model_uri: model.model_uri,
    vendor_name: model.vendor_name || null,
  }
}

export const initSurchargeObject = (): Surcharge => {
  return {
    id: '',
    active: false,
    amount: 0,
    amount_type: 'percentage',
    apply_to: 'configurators',
    calculation_order: 0,
    description: null,
    last_modified_date: null,
    last_modified_name: null,
    last_modified_email: null,
    last_modified_uid: null,
    configurators: [],
    name: ''
  }
}

export const toSurchargeApplicable = (surcharge: Surcharge, apply: boolean = false): SurchargeApplicable => {
  return {
    id: surcharge.id,
    active: surcharge.active,
    amount: surcharge.amount,
    amount_type: surcharge.amount_type,
    apply_to: surcharge.apply_to,
    calculation_order: surcharge.calculation_order,
    description: surcharge.description,
    name: surcharge.name,
    apply
  }
}
